export enum FeedbackSeverity {
  Compliment = 'Compliment',
  Suggestion = 'Suggestion',
  Complaint = 'Complaint',
  Other = 'Other'
}
